
import React from "react";
import { HeartHandshake, Sprout } from "lucide-react";
import Mycelium from "@/components/icons/Mycelium";

const WhySection = () => {
  return (
    <section className="py-16 container">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-earth-100 mb-6">
            <HeartHandshake className="w-5 h-5 text-eco-500 mr-2" />
            <span className="font-semibold text-eco-700">Why</span>
          </div>
          <h2 className="text-3xl font-bold mb-6 text-eco-700">We believe in the quiet power of connection.</h2>
          <p className="text-lg text-muted-foreground mb-6">
            Just like the mycelium beneath our feet, we grow stronger when we're linked. 
            Sharing ideas, energy and care helps us build something bigger than any of us could do alone.
          </p>
          <p className="text-lg text-muted-foreground mb-6">
            Ourcelium was born from a desire to reconnect with what matters most. 
            Nature. Community. Creativity. Care.
          </p>
          <p className="text-lg text-muted-foreground">
            If you're into alternative events, handmade things, herbal wisdom, soulful spaces 
            or just meeting like-minded people, you're not alone. There's a whole ecosystem out there. 
            We're here to help you find it.
          </p>
        </div>
        <div className="bg-gradient-to-br from-earth-50 to-earth-200 p-8 rounded-xl shadow-sm border border-earth-100 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-32 h-32 -mr-8 -mt-8 opacity-10">
            <Mycelium className="w-full h-full text-eco-700" strokeWidth={2} />
          </div>
          <div className="relative z-10">
            <Sprout className="w-12 h-12 text-eco-500 mb-6" />
            <h3 className="text-2xl font-semibold mb-4 text-eco-800">Rooted in Nature</h3>
            <p className="text-muted-foreground">
              Our name is inspired by mycelium - nature's original network that connects 
              plants and trees underground, sharing nutrients and information. Similarly, 
              we connect people with sustainable solutions, allowing communities to thrive together.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
